import Vue from 'vue'
import VueLocalStorage from 'vue-local-storage'
import isMobile from 'ismobilejs'

Vue.use(VueLocalStorage)

const defaultShowMap = !isMobile().any

export default {
  data() {
    return {
      showMap:
        this.$localStorage.get('showMap') !== null
          ? this.$localStorage.get('showMap')
          : defaultShowMap,
    }
  },
  localStorage: {
    showMap: {
      type: Boolean,
      default: defaultShowMap,
    },
  },
  watch: {
    showMap() {
      this.$localStorage.set('showMap', this.showMap)
    },
  },
  computed: {
    fixedControlIcon() {
      return `#${this.showMap ? 'stack' : 'pin'}`
    },
  },
}
